import { useModals } from "@/lib/modal";
import { ArrowRight, ArrowUpRight } from "lucide-react";

export const PrimaryCta = ({ children, onClick, testid, className = "" }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className={`group inline-flex items-center gap-2.5 rounded-lg bg-signal-cyan px-7 py-3.5 text-sm font-semibold tracking-wide text-ink-950 transition-[background-color,box-shadow,transform] duration-300 hover:bg-cyan-300 hover:shadow-[0_8px_40px_rgba(34,211,238,0.25)] hover:-translate-y-0.5 ${className}`}
  >
    {children}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </button>
);

export const SecondaryCta = ({ children, onClick, testid, className = "" }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className={`group inline-flex items-center gap-2.5 rounded-lg border border-white/20 px-7 py-3.5 text-sm font-semibold tracking-wide text-mist transition-[border-color,background-color,transform] duration-300 hover:border-white/60 hover:bg-white/[0.03] hover:-translate-y-0.5 ${className}`}
  >
    {children}
    <ArrowUpRight className="h-4 w-4 text-steel transition-colors duration-300 group-hover:text-signal-cyan" />
  </button>
);

export const JoinCta = ({ testid, className = "", children = "Join the Founding Network" }) => {
  const { openJoin } = useModals();
  return (
    <PrimaryCta testid={testid} onClick={openJoin} className={className}>
      {children}
    </PrimaryCta>
  );
};

export const ValidatorCta = ({ testid, className = "", children = "Become a Founding Verifier" }) => {
  const { openValidator } = useModals();
  return (
    <SecondaryCta testid={testid} onClick={openValidator} className={className}>
      {children}
    </SecondaryCta>
  );
};
